/*
 * File: d:\projects\AutoFiFront\src\Utils\BuildText.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 28th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 28th 2023 3:02:29 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { v4 as uuid } from 'uuid';

export function BuildText(data: any, context: string){
    return BuildSection(data, 0, context);
}

export function BuildSection(data: any, deepness: number, context: string){
    const myRows: any[] = [];

    for(let i = 0; i < data.sections.length; ++i){
        var title;
        const content: any[] = [];
        if (deepness == 0)
            title = <h2>{data.sections[i].sectionTitle}</h2>;
        else if (deepness == 1)
            title = <h3>{data.sections[i].sectionTitle}</h3>;
        else if (deepness == 2)
            title = <h4>{data.sections[i].sectionTitle}</h4>;
        else if (deepness == 3)
            title = <h5>{data.sections[i].sectionTitle}</h5>;
        if (data.sections[i].paragraphs != undefined && data.sections[i].paragraphs != null)
            content.push(data.sections[i].paragraphs.map((x:string) => {return (<p key={`${context}-${uuid().slice(0,8)}`}>{x}</p>)}));
        if (data.sections[i].sections != undefined && data.sections[i].sections != null)
            content.push(BuildSection(data.sections[i], deepness + 1, context));
        myRows.push(<div key={`section${context}-${uuid().slice(0,8)}`}>
            {title}
            {content}
        </div>)
    }

    return myRows;
}
